<template>
  <v-layout class="lot-card" column v-if="lot && lot.id">
    <div class="text-xs-center font-weight-regular headline">Lot Details</div>
    <div class="text-xs-center caption font-weight-light">{{lot.id}}</div>
    <div v-if="canAccess('LOT_EDIT')" class="edit-btn">
      <v-btn fab dark small color="primary" @click="handleEditLot(lot)" icon>
        <v-icon class="my-1">edit</v-icon>
      </v-btn>
    </div>

    <v-layout column class="px-3 py-2">
      <div class="label text-uppercase font-weight-bold px-3 py-2">Meat Processor</div>
      <div class="value font-weight-light px-3 py-2">{{getProcessor(lot.owner).name}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Type of Meat</div>
      <div class="value font-weight-light px-3 py-2">{{lot.ingredient.name}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Powder Shipment Date</div>
      <div class="value font-weight-light px-3 py-2">{{formatDate(lot.shipped_at)}}</div>

      <div class="label text-uppercase font-weight-bold px-3 py-2">Shipments</div>
      <div class="px-3 py-2">
        <div class="shipment" v-for="shipment in getShipmentsForLot(lot.id)" :key="shipment.id">
          <v-layout @click="expand(shipment)" column class="expand-header">
            <v-layout >
              <v-flex grow>
                <span class="font-weight-bold shipment-number">#{{shipment.id}}</span>
              </v-flex>
              <v-flex shrink v-bind:class="{rotate: ~expandedShipments.indexOf(shipment.id)}">
                <v-icon >
                  arrow_drop_down
                </v-icon>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout class="expand-content" :class="{'show-content': ~expandedShipments.indexOf(shipment.id)}" row wrap>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Butchering Date</label>
              <div class="pa-2 font-weight-light value">{{formatDate(shipment.produced_at)}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Shipment Date</label>
              <div class="pa-2 font-weight-light value">{{formatDate(shipment.shipped_at)}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Receiving Date</label>
              <div class="pa-2 font-weight-light value">{{formatDate(shipment.received_at)}}</div>
            </v-flex>
            <v-flex class="pa-2" xs6>
              <label class="pa-2 font-weight-bold text-uppercase label">Meat Processing Date</label>
              <div class="pa-2 font-weight-light value">{{formatDate(shipment.processed_at)}}</div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-layout>
    <div class="text-xs-center">Secured by Hyperledger Sawtooth</div>
    <a v-if="lot.blockchain" :href="lot.blockchain.state" class="text-xs-center hash">Hash:{{lot.blockchain.address}}</a>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/date.js'
import { canAccess } from '@/utils/permissions'

export default {
  name: 'LotCard',
  props: {
    lot: Object
  },
  computed: mapGetters({
    getProcessor: 'getProcessor',
    getShipmentsForLot: 'getShipmentsForLot'
  }),
  data () {
    return {
      expandedShipments: []
    }
  },
  methods: {
    canAccess,
    formatDate,
    expand (shipment) {
      let index = this.expandedShipments.indexOf(shipment.id)
      if (~index) {
        this.expandedShipments.splice(index, 1)
      } else {
        this.expandedShipments.push(shipment.id)
      }
    },

    handleEditLot (lot) {
      this.$router.push({ name: 'lots.edit', params: { id: lot.id, lot: lot, shipments: this.getShipmentsForLot(lot.id) } })
    }
  }
}
</script>

<style lang="scss" scoped>

.rotate{
  transform: rotateX(180deg)
}

.lot-card{
  position: relative;
}

.edit-btn{
  position: absolute;
  top: 0px;
  right: 0px;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #333333;
}

.caption{
  color: #888888;
  margin-bottom: 10px;
}

.shipment{
  margin-top: 3px;
}

.shipment-name{
  font-size: 16px
}

.shipment-number{
  font-size: 16px;
}

.infos-container{
  padding: 10px 25px;
}

.label{
  color: #858585;
  font-size: 12px;
}

.value{
  background: white;
  font-size: 16px;
}

.expand-header{
  padding: 5px 15px;
  background: #fafafa;
  cursor: pointer;
}

.expand-content{
  transition: 0.5s;
  max-height: 0;
  overflow: hidden;
}

.show-content{
  max-height: 300px;
}

</style>
